import type {
  AvailabilitySnapshot,
  BookingMutationInput,
  BookingMutationResult,
  IdempotencyRecord,
} from "../core/types";

export interface CrmPort {
  getAvailability(): Promise<AvailabilitySnapshot>;
  getIdempotencyRecord(key: string): Promise<IdempotencyRecord | null>;
  bookAppointment(input: BookingMutationInput): Promise<BookingMutationResult>;
}

export class StaleSnapshotError extends Error {
  constructor() {
    super("Availability changed before the mutation was committed.");
    this.name = "StaleSnapshotError";
  }
}

export class SlotUnavailableError extends Error {
  constructor() {
    super("The requested synthetic slot is no longer available.");
    this.name = "SlotUnavailableError";
  }
}

export class IdempotencyConflictError extends Error {
  constructor() {
    super("The idempotency key is already bound to a different mutation.");
    this.name = "IdempotencyConflictError";
  }
}
